import { lazy } from 'react';

// Lazy load heavy components for better performance
export const LazyUnifiedIntegrations = lazy(() => import('@/components/integrations/UnifiedIntegrations'));
export const LazyGuidedSession = lazy(() => import('@/components/sessions/GuidedSession'));
export const LazyPrivacySettings = lazy(() => import('@/components/privacy/PrivacySettings'));
export const LazySessionFlow = lazy(() => import('@/pages/session-detail/SessionFlow'));
export const LazySessionDetail = lazy(() => import('@/pages/SessionDetail'));
// Note: Integrations page doesn't exist as separate page
export const LazyDashboardMainContent = lazy(() => import('@/pages/dashboard/DashboardMainContent'));

// Loading component for lazy components
export { default as LazyLoadingFallback } from './LazyLoadingFallback';